import React from 'react';
import { useIntl } from 'react-intl';
import styled from 'styled-components';

import { Button, FieldRow, FormFooter, Title } from '@xsolla/ui-core';
import { AlertExclamationColorful } from '@xsolla/ui-icons';
import { Modal } from '@xsolla/ui-modal';

const Entry = styled.div`
  text-align: center;
  margin: 0 auto;
  padding: 20px 0;
  width: 100%;
`;

type Props = {
  onClose: () => void;
  onConfirm: () => void;
};

const BabkaDisconnectModal = ({ onClose, onConfirm }: Props): JSX.Element => {
  const intl = useIntl();

  const renderFooter = () => (
    <FormFooter>
      <FieldRow justify="space-between" stretched>
        <Button look="tertiary" palette="muted" onClick={onClose}>
          {intl.formatMessage({ id: 'button.cancel' })}
        </Button>
        <Button palette="danger" onClick={onConfirm} data-test-id="btn-babka-disconnect-confirm">
          {intl.formatMessage({ id: 'social-connection.card.settings.disconnect' })}
        </Button>
      </FieldRow>
    </FormFooter>
  );

  return (
    <Modal>
      <Entry>
        <AlertExclamationColorful size={40} />
        <Title center indent="sm">
          {intl.formatMessage({ id: 'social-connection.babka-disconnect.title' })}
        </Title>
        <p>{intl.formatMessage({ id: 'social-connection.babka-disconnect.description' })}</p>
      </Entry>
      {renderFooter()}
    </Modal>
  );
};

export default BabkaDisconnectModal;
